<template>
    <div class="wrapper-modal js-modal-content" :class="{ active: isActive }">
        <div class="wrapper-modal__overlay" @click="showModal"></div>
        <div class="wrapper-modal__block">
            <h2 class="wrapper-modal__title">Куда вас перенаправить?</h2>
            <button class="wrapper-modal__close" @click="showModal">
                <img src="/assets/img/roller/close.svg" alt="" />
            </button>
            <div class="wrapper-modal__flex">
                <div class="wrapper-modal__card">
                    <img
                        class="wrapper-modal__card_img"
                        src="/assets/img/roller/main-modal-1.jpg"
                        alt=""
                    />
                    <div class="wrapper-modal__card_content">
                        <div class="wrapper-modal__card_title">
                            Солнцезащита
                        </div>
                        <div class="wrapper-modal__card_text">
                            Изготовление солнцезащитных решений для дома и улицы
                        </div>
                        <button
                            class="wrapper-modal__card_button btn _primary"
                            @click="showModal"
                        >
                            Перейти
                        </button>
                    </div>
                </div>
                <div class="wrapper-modal__card">
                    <img
                        class="wrapper-modal__card_img"
                        src="/assets/img/roller/main-modal-2.jpg"
                        alt=""
                    />
                    <div class="wrapper-modal__card_content">
                        <div class="wrapper-modal__card_title">Мебель</div>
                        <div class="wrapper-modal__card_text">
                            Изготовление мебели любой сложности на заказ
                        </div>
                        <a
                            class="wrapper-modal__card_button btn _primary"
                            href="https://rolatex-mebell.ru"
                            target="_blank"
                        >
                            Перейти
                        </a>
                    </div>
                </div>
                <div class="wrapper-modal__card">
                    <img
                        class="wrapper-modal__card_img"
                        src="/assets/img/roller/main-modal-3.jpg"
                        alt=""
                    />
                    <div class="wrapper-modal__card_content">
                        <div class="wrapper-modal__card_title">
                            Металлоконструкции 22
                        </div>
                        <div class="wrapper-modal__card_text">
                            из металла и алюминия любой сложности под заказ
                        </div>
                        <a
                            class="wrapper-modal__card_button btn _primary"
                            href="https://rolatex-metall.ru"
                            target="_blank"
                        >
                            Перейти
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.wrapper-modal {
    width: 100%;
    height: 100%;
    display: none;
    align-items: center;
    justify-content: center;
    position: fixed;
    background-color: rgba(0, 0, 0, 0.6);
    top: 0;
    left: 0;
    z-index: 101;
    border-radius: 5px;
    padding: 100px 15px 150px;
    overflow-y: auto;
}

.wrapper-modal.active {
    display: flex;
}

.wrapper-modal__overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 101;
}

.wrapper-modal__block {
    width: 100%;
    max-width: 980px;
    height: auto;
    z-index: 2;
    border: 1px solid black;
    background-color: #ffffff;
    border-radius: 5px;
    padding: 10px;
    position: relative;
    z-index: 102;
}

.wrapper-modal__close {
    position: absolute;
    right: 20px;
    top: 20px;
}

.wrapper-modal__title {
    text-align: center;
    font-weight: 600;
    font-size: 36px;
    margin-bottom: 8px;
}

.wrapper-modal__flex {
    display: flex;
    justify-content: space-between;
    gap: 15px;
}

.wrapper-modal__card {
    position: relative;
    width: 100%;
    border-radius: 5px;
    overflow: hidden;
}

.wrapper-modal__card_img {
    width: 100%;
    height: 300px;
    object-fit: cover;
}

.wrapper-modal__card_content {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 20px;
}
.wrapper-modal__card_title {
    font-size: 22px;
    font-weight: 600;
    color: #ffffff;
}
.wrapper-modal__card_text {
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
    margin-bottom: 10px;
}
@media screen and (max-width: 800px) {
    .wrapper-modal__flex {
        flex-direction: column;
    }

    .wrapper-modal {
        align-items: flex-start;
    }

    .wrapper-modal__title {
        font-size: 25px;
    }

    .wrapper-modal__close {
        right: 10px;
        top: 10px;
    }

    .wrapper-modal__title {
        margin-top: 30px;
    }
}
</style>

<script>
export default {
    name: 'ChooseSite',
    data() {
        return {
            isActive: true,
        };
    },

    mounted() {
        if (sessionStorage.getItem('modal_showed')) {
            this.isActive = false;
        }
    },

    methods: {
        showModal() {
            this.isActive = false;
            sessionStorage.setItem('modal_showed', true);
        },
    },
};
</script>
